<template>
  <div class="mt-component-form">
    <vs-row class="my-4 ">
      <h5 style="align-self: center"><i class="dot"></i>{{ $t('건강상담') }}</h5>
      <div class="ml-auto">
        <vs-button
          v-if="!isPrint && !isReadonly"
          class=""
          color="secondary"
          type="border"
          @click="handleAddRow">{{ $t('항목추가') }}</vs-button>
        <vs-button
          v-if="!isPrint && !isReadonly"
          class="ml-4"
          color="secondary"
          @click="handleRemoveRow">{{ $t('선택삭제') }}</vs-button>
      </div>
    </vs-row>

    <!-- row -->
    <div
      class="grid mb-6 write361"
      :style="{gridTemplateColumns : `${isPrint || isReadonly ? '' : '36px'} 1fr`}"
      v-for="(row, indexRow) in equipmentList"
      :key="indexRow"
    >
      <div v-if="!isPrint && !isReadonly" class="none-border-center th">
        <vs-checkbox v-model="row.is_checked"></vs-checkbox>
      </div>
      <div>
        <!--첫번째 줄-->
        <div class="grid" style="grid-template-columns: 100px 2fr 100px 2fr 100px 1.8fr 1.8fr 100px 0.9fr 0.9fr 0.9fr 0.9fr;">
          <div class="th">{{ $t('일자') }}</div>
          <div class="td">
            <date-selector class="w-full" v-model="row['일자']" placeholder="날짜" :readonly="isReadonly || isPrint"></date-selector>
          </div>
          <div class="th">{{ $t('시간') }}</div>
          <div class="td">
            <time-selector class="w-full" v-model="row['시간']" placeholder="날짜" :readonly="isReadonly || isPrint"></time-selector>
          </div>
          <div class="th">{{ $t('상담자') }}</div>
          <div class="td" style="grid-column: span 2;">
            <ml-input v-model="row['상담자']" class="w-full" />
          </div>
          <div class="th">{{ $t('체지방') }}</div>
          <div class="td" style="grid-column: span 4;">
            <ml-input v-model="row['체지방']" class="w-full" />
          </div>

          <div class="th" style="grid-row: span 6;">{{ $t('교육내용') }}</div>
          <div class="grid" style="grid-template-columns: 1fr 60px; grid-column: 2/5; grid-row: 2/4;">
            <div class="td">{{ $t('전문의 진료 권장/확인 서류 제출') }}</div>
            <div class="td" style="align-items: center">
              <vs-checkbox v-model="row['전문의']"></vs-checkbox>
            </div>
          </div>
          <div class="grid" style="grid-template-columns: 1fr 60px; grid-column: 2/5; grid-row: 4/6;">
            <div class="td">{{ $t('주기적 건강체크 권장') }}</div>
            <div class="td" style="align-items: center">
              <vs-checkbox v-model="row['주기적']"></vs-checkbox>
            </div>
          </div>
          <div class="grid" style="grid-template-columns: 1fr 60px; grid-column: 2/5; grid-row: 6/8;">
            <div class="td">{{ $t('생활요법 권장') }}</div>
            <div class="td" style="align-items: center">
              <vs-checkbox v-model="row['생활요법']"></vs-checkbox>
            </div>
          </div>

          <div class="th" style="grid-column: 5/6;grid-row: span 6;">{{ $t('간이검사') }}</div>
          <div class="th" style="grid-column: 6/7; grid-row:2/5">{{ $t('혈압') }}</div>
          <div class="th" style="grid-column: 7/8; grid-row:2/5">{{ $t('혈당') }}</div>
          <div class="td" style="grid-column: 6/7; grid-row:5/8">
            <ml-input v-model="row['간이검사.혈압']" class="w-full" />
          </div>
          <div class="td" style="grid-column: 7/8; grid-row:5/8">
            <ml-input v-model="row['간이검사.혈당']" class="w-full" />
          </div>

          <div class="th" style="grid-column: 8/9;grid-row: span 6;">{{ $t('콜레스테롤') }}</div>
          <div class="th" style="grid-column: 9/10; grid-row:2/5">TC</div>
          <div class="th" style="grid-column: 10/11; grid-row:2/5">TG</div>
          <div class="th" style="grid-column: 11/12; grid-row:2/5">HDL</div>
          <div class="th" style="grid-column: 12/13; grid-row:2/5">LDL</div>
          <div class="td" style="grid-column: 9/10; grid-row:5/8">
            <ml-input v-model="row['콜레스테롤.TC']" class="w-full" />
          </div>
          <div class="td" style="grid-column: 10/11; grid-row:5/8">
            <ml-input v-model="row['콜레스테롤.TG']" class="w-full" />
          </div>
          <div class="td" style="grid-column: 11/12; grid-row:5/8">
            <ml-input v-model="row['콜레스테롤.HDL']" class="w-full" />
          </div>
          <div class="td" style="grid-column: 12/13; grid-row:5/8">
            <ml-input v-model="row['콜레스테롤.LDL']" class="w-full" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";

export default {
  name: 'Table361HealthCounseling',
  components: {TimeSelector, DateSelector},
  props: {
    list: Array,
    isPrint: Boolean,
    isReadonly: Boolean,
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler (value) {
        if (value && value.length > 0) {
          this.equipmentList = value
        }
      },
    },
  },
  methods: {
    checkForm (value, indexRow, text) {
      if (value.target.checked) {
        this.$emit('update-list-check', indexRow - 1, text)
      } else {
        this.$emit('update-list-check', indexRow - 1, '')
      }
    },
    // 항목추가
    handleAddRow () {
      this.equipmentList.push({
        is_checked: this.equipAllCheck,
        name: '',
        manufacturer: '',
        standard: '',
      })
      this.updateList()
    },
    // 선택삭제
    handleRemoveRow () {
      for (let i = 0; i < this.equipmentList.length; i++) {
        if (this.equipmentList[i].is_checked) {
          this.equipmentList.remove(this.equipmentList[i])
          i = -1
        }
      }

      this.equipAllCheck = false
      this.updateList()
    },
    // 일괄 체크
    changeAllCheck () {
      for (const data of this.equipmentList) {
        data.is_checked = this.equipAllCheck
      }
    },
    // update
    updateList () {
      this.$emit('updateList', this.equipmentList)
    },
  },
  data () {
    return {
      equipAllCheck: false,
      equipmentList: [],
    }
  },
}
</script>
<style>
.write361 .vs-checkbox {
  margin-right: 0 !important;
}
</style>
<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  margin: 0;
}

/* Table */
.row-header {
  background-color: $bg;
  text-align: center;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}
.row-header__item {
  border: $border;
  border-left: none;
  border-right: none;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: none;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  border-bottom: $border;
  &__title {
    background-color: $bg;
    height: 100%;
  }
  &__body {
  }
}
.row-content__body-item {
  .item-content {
    padding: 15px;
    border-left: $border;

    pre {
      font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
      white-space: pre-wrap;
    }
  }
  .item-box {
    border-left: $border;
    border-right: $border;
    display: flex;
    .item-box-check {
      flex: 1;
      justify-content: center !important;
    }
    .item-box-check:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
  .item-area {
    padding: 5px;
    align-self: center;
  }
}
.row-content__body-item ~ .row-content__body-item {
  border-top: $border;
}
.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
.row-content-none-data {
  height: 120px;
  border-bottom: $border;
  display: flex;
  justify-content: center;
  align-items: center;
}
.th {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 54px;
  background-color: #f9f9f9;
  outline: $border;
  text-align: center;
}
.td {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 7px;
  outline: $border;
}
</style>
